import {injectable} from 'inversify';

import type {LighteningWeight} from '../../../styles/utils/getLighteningColor';
import type {Nullable} from '../../../utils/utility-types';

import {
  getColor,
  getLighteningColor,
  type Theme,
  type ThemeAndAnyColor,
} from '../../../styles';

/**
 * Service responsible for managing and providing theme-related utilities as injectable service.
 * This includes theme change handling, retrieving specific theme colors,
 * and lightening colors based on a specified weight.
 */
@injectable()
export class ThemeProviderService {
  theme: Nullable<Theme> = null;

  getColor(color: ThemeAndAnyColor) {
    if (!this.theme) {
      // eslint-disable-next-line no-console
      console.warn('theme is not defined');

      return color;
    }

    return getColor(color)({theme: this.theme});
  }

  getLighteningColor(color: ThemeAndAnyColor, weight: LighteningWeight) {
    if (!this.theme) {
      // eslint-disable-next-line no-console
      console.warn('theme is not defined');

      return color;
    }

    return getLighteningColor(color, weight)({theme: this.theme});
  }

  setTheme: ThemeProviderService.ThemeChangeCb = ({theme}) => {
    this.theme = theme;
  };
}

export namespace ThemeProviderService {
  export type ThemeChangeCb = (props: {theme: Theme}) => void;
}
